export const container = {
  xxs: "24rem",
  xs: "40rem",
  s: "48rem",
  m: "64rem",
  l: "80rem",
  xl: "90rem",
  xxl: "120rem"
};
export const mediaQuery = {
  xxs: "(min-width: 24rem)",
  xs: "(min-width: 40rem)",
  s: "(min-width: 48rem)",
  m: "(min-width: 64rem)",
  l: "(min-width: 80rem)",
  xl: "(min-width: 90rem)",
  xxl: "(min-width: 120rem)"
};
export const mediaQueryMax = {
  xxs: "(max-width: 24rem)",
  xs: "(max-width: 40rem)",
  s: "(max-width: 48rem)",
  m: "(max-width: 64rem)",
  l: "(max-width: 80rem)",
  xl: "(max-width: 90rem)",
  xxl: "(max-width: 120rem)"
};
//# sourceMappingURL=vars.js.map